import { NavSection, StickyNavbarProps } from "./types"
import Link from "next/link"

const StickyNavbar: React.FC<StickyNavbarProps> = ({
  sections,
  activeSection,
  isVisible,
  activeColor,
}) => {
  const isActive = (section: NavSection) => {
    const ids = section.activeIds || [section.id]
    return ids.includes(activeSection)
  }
  const handleScroll = (section: NavSection) => {
    const element = document.getElementById(section.id)
    if (element) {
      const viewportHeight = window.innerHeight
      const adjustment = section.adjustment ? viewportHeight * section.adjustment : 0

      const elementPosition = element.getBoundingClientRect().top + window.scrollY
      window.scrollTo({
        top: elementPosition + adjustment,
        behavior: "smooth",
      })
    }
  }

  return (
    <nav
      className={`fixed left-0 right-0 top-0 z-50 max-w-[100vw] cursor-pointer overflow-x-hidden bg-[#171717]/80 px-3 py-2 text-sm font-bold tracking-tight text-white transition-opacity duration-300 md:px-8 md:py-3 md:text-2xl ${
        isVisible ? "opacity-100" : "pointer-events-none opacity-0"
      }`}
    >
      <div className="mx-auto max-w-3xl xl:max-w-5xl">
        <div className="flex items-center justify-between text-center leading-4 md:leading-7">
          {sections.map((section) => (
            <Link
              key={section.id}
              href={`#${section.id}`}
              style={{
                color: isActive(section) ? activeColor : undefined,
              }}
              className={`py-2 transition-colors duration-200 hover:opacity-75 ${
                isActive(section) ? "" : ""
              }`}
              onClick={(e) => {
                e.preventDefault()
                handleScroll(section)
              }}
            >
              <div>{section.labelTop}</div>
              <div>{section.labelBottom}</div>
            </Link>
          ))}
        </div>
      </div>
    </nav>
  )
}

export default StickyNavbar
